module.exports = __webpack_public_path__ + "static/media/icon_u.b025d01f.svg";